module.exports = __webpack_public_path__ + "static/media/Shadow Demon.64fbaa13.png";